import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, withLatestFrom } from 'rxjs/operators';
import { CardOnFile } from '../../../dtos/response/card-on-file-response/card-on-file';
import { CardOnFileService } from '../../../services/card-on-file-service/card-on-file.service';
import { ReservationServiceSelectors } from '../../../services/reservation-service/state/reservation-service.selectors';
import { RootState } from '../../../state/state';
import { loadCardsOnFile, loadCardsOnFileLookupComplete } from './card-on-file-service.actions';

@Injectable()
export class CardOnFileServiceEffects {
  private readonly actions$ = inject(Actions);
  private readonly cardOnFileService = inject(CardOnFileService);
  private readonly store = inject<Store<RootState>>(Store);

  getCardsOnFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCardsOnFile),
      withLatestFrom(this.store.pipe(select(ReservationServiceSelectors.getMileagePlanForAllPassengersOnActiveReservation))),
      exhaustMap(([action, reservationMileagePlanNumbers]) => {
        // Allow user input mp numbers override.
        const mps = action.mileagePlanNumbers ?? reservationMileagePlanNumbers;
        // Dedup the mileage plan numbers before making the service call
        const uniqueMps = Array.from(new Set(mps));
        if (uniqueMps?.length > 0) {
          return this.cardOnFileService.getCardsOnFileForMileagePlanNumbers(uniqueMps).pipe(
            map((cardOnFileResponse) => {
              return loadCardsOnFileLookupComplete(cardOnFileResponse.cardsOnFile, cardOnFileResponse.success);
            }),
            catchError((error) => {
              return of(loadCardsOnFileLookupComplete(null, false));
            })
          );
        }
        return of(loadCardsOnFileLookupComplete([] as CardOnFile[], true));
      })
    )
  );
}
